var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvrbedFirmnessBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 577.636,
    height: 454.8,
    viewBox: "0 0 577.636 454.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.843,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6fcfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#f1fafe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#abe1fa"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7821",
    x: 0,
    y: 0,
    width: 577.636,
    height: 454.8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.169
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_7821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7821-2",
    "data-name": "Path 7821",
    d: "M333.4,454.276s3.158-229.314,0-309.775S259.8,25.716,259.8,25.716,230.966,5.47,187.053,1.683s-184.245,0-184.245,0-6.317,270.55,0,321.844,39.85,84.539,54.442,96.488,40.387,26.7,78.215,34.261S333.4,454.276,333.4,454.276Z",
    transform: "translate(517.64 60) rotate(90)",
    fill: "url(#radial-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvrbedFirmnessBackground);
export default __webpack_public_path__ + "static/media/evrbed_firmness_background.e5fa38ad4605e8eaf104d224f22ffe97.svg";
export { ForwardRef as ReactComponent };